import { type ApiClientResponse, apiClient } from "@lobby/api-client";
import { queryClient } from "@lobby/core/src/app";
import { redirect } from "@tanstack/react-router";

import { loadGameCategoryList } from "./loaders";

const DOMAIN_WITH_DEFAULT_REGISTER = ["betboycasino1.com"];

function domainFixedQuery(): { modal: "register" | "log-in" | "password-forgot" } {
  if (DOMAIN_WITH_DEFAULT_REGISTER.includes(window.location.hostname)) {
    return {
      modal: "register",
    };
  }

  return {
    modal: "log-in",
  };
}

export async function ensureUserIsAuthenticated() {
  const data = await queryClient.ensureQueryData<ApiClientResponse<"Player.getCurrent">>({
    queryKey: ["Player.getCurrent"],
    queryFn: () =>
      apiClient.send({
        endpoint: "Player.getCurrent",
        params: { isActive: "true" },
      }),
  });

  return Boolean(data.result);
}

export function isLobbyDemoMode() {
  return import.meta.env.VITE_IS_DEMO === "true";
}

export async function redirectIfUserIsAuthenticated(to: string) {
  const isAuthenticated = await ensureUserIsAuthenticated();
  if (isAuthenticated) {
    throw redirect({
      to,
    });
  }
}

export async function redirectIfAuthenticatedUserRequired() {
  if (isLobbyDemoMode()) return;

  const isAuthenticated = await ensureUserIsAuthenticated();
  if (!isAuthenticated) {
    throw redirect({
      to: "/sign-in",
      replace: true,
      search: domainFixedQuery(),
    });
  }
}

export async function redirectIfFortuneWheelIsNotAvailable() {
  const data = await queryClient.ensureQueryData<ApiClientResponse<"Lobby.getCurrent">>({
    queryKey: ["Lobby.getCurrent"],
    queryFn: () =>
      apiClient.send({
        endpoint: "Lobby.getCurrent",
      }),
  });

  const isFortuneWheelAvailable = Boolean(data.result?.fortuneWheel?.isActive);
  if (!isFortuneWheelAvailable) {
    throw redirect({
      to: "/",
      replace: true,
    });
  }
}

export async function redirectToIndexCategory() {
  const categoryListResponse = await loadGameCategoryList();

  const categories = categoryListResponse.result?.data ?? [];
  const indexCategory = categories.find(({ tag }) => tag === "header");

  if (indexCategory) {
    switch (indexCategory.actionType) {
      case "game":
        throw redirect({
          to: "/game/$gameId",
          params: { gameId: indexCategory.actionData as string },
        });
      case "category":
        throw redirect({
          to: "/casino",
          search: { cid: indexCategory.id },
        });
      default:
        throw redirect({
          to: "/casino",
        });
    }
  } else {
    throw redirect({
      to: "/casino",
    });
  }
}
